<!-- =========================================================================================
  File Name: Session.vue
  Description: Session Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Sesión no encontrada" :active.sync="id_not_found">
      <span>Datos de sesión con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'sessions'}" class="text-inherit underline"> todas las sesiones</router-link>
      </span>
    </vs-alert>

    <vx-card v-show="loaded" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1">
            <div class="w-full">
              <div class="w-full vx-row">
                <div class="vx-col w-1/3">
                  <ejs-datetimepicker floatLabelType="Auto" placeholder="Fecha de apertura" :readonly="true" v-model="data_local.openDate"/>
                </div>
                <div class="vx-col w-1/3">
                  <span v-show="data_local.statusId == 'C'">
                    <ejs-datetimepicker floatLabelType="Auto" placeholder="Fecha de cierre" :readonly="true" v-model="data_local.closeDate"/>
                  </span>
                </div>
                <div class="vx-col w-1/3 text-right">
                  <h5 class="mt-3"><b>{{ data_local.statusName }}</b></h5>
                </div>
              </div>
              <div class="w-full vx-row">
                <div class="vx-col w-1/2">
                  <ejs-textbox floatLabelType="Auto" placeholder="Caja" :readonly="true" v-model="data_local.cashRegisterName"/>
                </div>
                <div class="vx-col w-1/2">
                  <ejs-textbox floatLabelType="Auto" placeholder="Operador" :readonly="true" v-model="data_local.userName"/>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row mt-2">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button class="ml-auto" @click="close" v-show="data_local.statusId == 'A'">Cerrar sesión de caja</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card v-show="loaded">
      <ejs-tab ref="tabs">
        <div class="e-tab-header">
          <div>Resumen de pagos</div>
          <div>Lista de transacciones</div>
        </div>
        <div class="e-content">
          <div>
            <ejs-grid
              ref="gridPayments"
              :dataSource="data_local.paymentSummary"
              locale='es-GT'
              :toolbar='toolbarOptions'
              :allowPaging="true"
              :pageSettings='pageSettings'
              :allowExcelExport='true'
              :toolbarClick='paymentsToolbarClick'
              v-if="loaded"
            >
              <e-columns>
                <e-column field="paymentMethodId" :visible=false headerText="ID" :isPrimaryKey="true"/>
                <e-column field="paymentMethodName" headerText="Forma de pago"/>
                <e-column field='amount' headerText="Monto" type="number" textAlign='Right' format="N2" width="130"/>
              </e-columns>
            </ejs-grid>
          </div>
          <div>
            <ejs-grid
              ref="gridTransactions"
              :dataSource="data_local.transactionList"
              locale='es-GT'
              :toolbar='toolbarOptions'
              :allowPaging="true"
              :pageSettings='pageSettings'
              :allowSorting='true'
              :sortSettings='sortOptions'
              :allowExcelExport='true'
              :toolbarClick='transactionsToolbarClick'
              v-if="loaded"
            >
              <e-columns>
                <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true"/>
                <e-column field="date" headerText="Fecha" width="180" :valueAccessor="formatDate"/>
                <e-column field="documentType" headerText="Tipo" width="100"/>
                <e-column field="document" headerText="Documento" width="250"/>
                <e-column field="customerName" headerText="Cliente"/>
                <e-column field="customerVAT" headerText="NIT" width="200"/>
                <e-column field='amount' headerText="Monto" type="number" textAlign='Right' format="N2" width="130"/>
                <e-column field="statusName" headerText="Estado" width="100"/>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </ejs-tab>
    </vx-card>

  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DateTimePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import {TabPlugin} from '@syncfusion/ej2-vue-navigations';
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport} from '@syncfusion/ej2-vue-grids';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week

  Vue.use(TextBoxPlugin);
  Vue.use(DateTimePickerPlugin);
  Vue.use(TabPlugin);
  Vue.use(GridPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'grid': {
        'EmptyRecord': 'No se encontraron datos',
        'Search': 'Buscar',
        'Excelexport': 'Exportar'
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        loaded: false,
        pageSettings: {pageSize: 15},
        toolbarOptions: ['Search', 'ExcelExport'],
        sortOptions: {columns: [{field: 'date', direction: 'Ascending'}, {field: 'document', direction: 'Ascending'}]},
        editing: false,
        data: null,
        id: 0,
        data_local: {
          id: 0,
          userName: '',
          cashRegisterName: '',
          statusId: 'IN',
          statusName: ''
        },
        id_not_found: false,
      }
    },
    provide: {
      grid: [Toolbar, Search, Page, Sort, ExcelExport]
    },
    methods: {
      formatDate: function (field, data) {
        var d = new Date(data[field].replace('Z', ''));
        // return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth()+1).toString().padStart(2, '0')}/${d.getFullYear()}`;
        return `${d.getDate().toString().padStart(2, '0')}/${d.getMonth().toString().padStart(2, '0')}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
      },
      paymentsToolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) {
          let excelExportProperties = {
            fileName: "PagosSesión.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
        }
      },
      transactionsToolbarClick: function (args) {
        if (args.item.id.includes('excelexport')) {
          let excelExportProperties = {
            fileName: "TransaccionesSesión.xlsx"
          };
          this.$refs.grid.excelExport(excelExportProperties);
        }
      },
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'sessions'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            var data = {
              id: id,
              context: this.$store.state.AppActiveUser
            };
            this.$http.post(deltaPOS_config.default.apiURL + '/sale/cash_register/get_session_data', data).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      close() {
        this.$vs.loading({
          text: 'Guardando información de sesión',
          type: 'point'
        });
        var self = this;
        this.data_local.id = this.id;
        this.data_local.context = this.$store.state.AppActiveUser;
        this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
        this.$http.post(deltaPOS_config.default.apiURL + '/sale/session/close', this.data_local).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Sesión de caja cerrada correctamente',
              color: 'primary'
            });
            self.getData(self.id);
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando datos de sesión',
          type: 'point'
        });
      }
      this.getData(this.id);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
